<template>
  <vs-row vs-align="flex-start" vs-type="flex" vs-justify="left" vs-w="12">
    <vs-col
      v-for="(item, index) in images"
      :key="index"
      vs-type="flex"
      vs-justify="left"
      vs-align="left"
      vs-w="20%"
    >
      <div
        :id="`image-${loadingClass}-${index}`"
        class="vs-con-loading__container"
      >
        <div class="mb-6 mr-1">
          <div
            v-if="determineFileType(item.photoUrl) !== 'pdf'"
            class="img-div mb-2 relative"
          >
            <a :href="item.photoUrl" target="_blank">
              <img :src="item.photoUrl" class="" />
            </a>
            <div class="image-trash absolute" v-if="from !== 'details'">
              <feather-icon
                @click="
                  removeImage(item.photoUrl, `image-${loadingClass}-${index}`)
                "
                icon="Trash2Icon"
              ></feather-icon>
            </div>
          </div>

          <div v-else class="img-div pdf-div mb-2 relative">
            <a :href="item.photoUrl" target="_blank">View File</a>
            <div class="image-trash absolute" v-if="from !== 'details'">
              <feather-icon
                @click="
                  removeImage(item.photoUrl, `image-${loadingClass}-${index}`)
                "
                icon="Trash2Icon"
              ></feather-icon>
            </div>
          </div>
        </div>
      </div>
    </vs-col>
  </vs-row>
</template>

<script>

export default {
  props: ['loadingClass', 'images', 'from'],
  inject: ['$validator'],
  data() {
    return {};
  },
  methods: {
    removeImage(url, selector) {
      this.$emit('removeImage', url, selector, this.loadingClass);
    },
    determineFileType(str) {
      var res = str.substring(str.length - 3, str.length);
      return res;
    },
  },
};
</script>

<style scoped>
.img-div {
  width: 150px;
  height: 150px;
  border: 2px solid #ddd;
  overflow: hidden;
}

.img-div img {
  max-width: 100% !important;
  height: auto !important;
  display: block;
  margin: 0 auto;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.pdf-div {
  border: 2px solid #ddd;
}

.pdf-div a {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-weight: 700;
  font-size: 20px;
}

.img-div img {
  width: 100%;
  height: 100%;
}

.image-trash {
  top: 0;
  cursor: pointer;
  color: #fff;
  background: darkred;
  padding: 2px 5px;
}
</style>
